import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

// Pages
import StaysPage from './pages/StaysPage';
import EligibilityPage from './pages/EligibilityPage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import StayRequestPage from './pages/StayRequestPage';
import PartnerApplicationPage from './pages/PartnerApplicationPage';
import ContactPage from './pages/ContactPage';
import AdminDashboard from './pages/AdminDashboard';
import CaregiverDashboard from './pages/CaregiverDashboard';
import PartnerDashboard from './pages/PartnerDashboard';
import FAQPage from './pages/FAQPage';
import SolutionPage from './pages/SolutionPage';
import HowItWorksPage from './pages/HowItWorksPage';
import ForCaregiversPage from './pages/ForCaregiversPage';
import ForPartnersPage from './pages/ForPartnersPage';
import ForMutuellesPage from './pages/ForMutuellesPage';
import AboutPage from './pages/AboutPage';
import QualitySecurityPage from './pages/QualitySecurityPage';
import ThankYouPage from './pages/ThankYouPage';
import LegalPage from './pages/LegalPage';
import PartnersMapPage from './pages/PartnersMapPage';

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/connexion" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const hideNavFooter = pathname.startsWith('/admin');
  const hideFooter = pathname === '/carte-partenaires';
  return (
    <>
      {!hideNavFooter && <Navbar />}
      <main className={hideNavFooter ? '' : 'pt-0'}>{children}</main>
      {!hideNavFooter && !hideFooter && <Footer />}
    </>
  );
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/connexion" element={<LoginPage />} />
        <Route path="/solution" element={<SolutionPage />} />
        <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
        <Route path="/nos-sejours" element={<StaysPage />} />
        <Route path="/tester-mon-eligibilite" element={<EligibilityPage />} />
        <Route path="/pour-les-aidants" element={<ForCaregiversPage />} />
        <Route path="/pour-les-partenaires" element={<ForPartnersPage />} />
        <Route path="/pour-les-mutuelles" element={<ForMutuellesPage />} />
        <Route path="/qualite-securite" element={<QualitySecurityPage />} />
        <Route path="/a-propos" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/demander-un-sejour" element={<StayRequestPage />} />
        <Route path="/devenir-partenaire" element={<PartnerApplicationPage />} />
        <Route path="/merci" element={<ThankYouPage />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
        <Route path="/confidentialite" element={<LegalPage />} />
        <Route path="/cgu" element={<LegalPage />} />
        <Route path="/cookies" element={<LegalPage />} />
        <Route path="/admin" element={
          <ProtectedRoute roles={['super_admin', 'admin_ops']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/espace-aidant" element={
          <ProtectedRoute roles={['caregiver']}>
            <CaregiverDashboard />
          </ProtectedRoute>
        } />
        <Route path="/espace-partenaire" element={
          <ProtectedRoute roles={['partner']}>
            <PartnerDashboard />
          </ProtectedRoute>
        } />
        <Route path="/carte-partenaires" element={
          <ProtectedRoute>
            <PartnersMapPage />
          </ProtectedRoute>
        } />
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center bg-background" data-testid="not-found-page">
            <div className="text-center">
              <h1 className="font-heading text-6xl font-bold text-primary mb-4">404</h1>
              <p className="text-muted-foreground mb-6">Page introuvable</p>
              <a href="/" className="text-accent hover:underline font-medium">Retour à l'accueil</a>
            </div>
          </div>
        } />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
